
export default class Header {

	static getHolderSelectors = () => ['header.header'];

	/** @type {HTMLElement} */
	#holderElement;
	/** @type {HTMLElement} */
	#mainMenu;
	/** @type {int} */
	#initialMainMenuHeight;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;

		this.#mainMenu = this.#holderElement.querySelector('.main-menu');
		this.#initialMainMenuHeight = this.#mainMenu.offsetHeight;
		const navMenu = this.#holderElement.querySelector('.nav-menu');
		const ticketsMenu = this.#holderElement.querySelector('.tickets-menu');

		const navButton = this.#holderElement.querySelector('.nav-menu-button');
		const ticketsButton = this.#holderElement.querySelector('.tickets-menu-button');

		this.#mainMenu.style.height = this.#initialMainMenuHeight + 'px';

		navButton.addEventListener('click', () => {
			ticketsButton.classList.remove('open');
			ticketsMenu.classList.remove('open');
			this.#toggleMenu(navMenu);
		});

		ticketsButton.addEventListener('click', () => {
			ticketsButton.classList.toggle('open');
			navMenu.classList.remove('open');
			this.#toggleMenu(ticketsMenu);
		});

		document.addEventListener('click', (event) => {
			if (!event.composedPath().includes(this.#mainMenu)) {
				navMenu.classList.remove('open');
				ticketsMenu.classList.remove('open');
				this.#mainMenu.style.height = this.#initialMainMenuHeight + 'px';
			}
		});


		let scrolled = false;
		let ticking = false;
		document.addEventListener('scroll', (event) => {

			if (!ticking) {
				window.requestAnimationFrame(() => {
					if (window.scrollY > 100 && !scrolled) {
						scrolled = true;
						this.#holderElement.classList.add('scrolled');
					} else if (window.scrollY <= 100 && scrolled) {
						scrolled = false;
						this.#holderElement.classList.remove('scrolled');
					}
					ticking = false;
				});
				ticking = true;
			}
		});

		let resizeTick = false;
		window.addEventListener('resize', () => {
			if (!resizeTick) {
				window.requestAnimationFrame(() => {
					this.#mainMenu.style.height = null;
					this.#initialMainMenuHeight = this.#mainMenu.offsetHeight;
					this.#mainMenu.style.height = this.#initialMainMenuHeight + 'px';
					resizeTick = false;
				});
			}
			resizeTick = true;
		});

	}

	/**
	 *
	 * @param {HTMLElement} menu
	 */
	#toggleMenu(menu) {
		if (menu.classList.contains('open')) {
			menu.classList.remove('open');
			this.#mainMenu.style.height = this.#initialMainMenuHeight + 'px';
		} else {
			window.setTimeout(() => menu.classList.add('open'), 100);
			this.#mainMenu.style.height = (this.#initialMainMenuHeight + menu.offsetHeight) + 'px';
		}
	}

}
